import './TagChip.css';

// Segment chip. The colour comes from the tag row, which the API only ever
// stores as a validated 6-digit hex (see tags.controller.js normalizeColour),
// so it's safe to put straight into a style.
//
// Chips carry their own text colour rather than inheriting: a pale tag on a
// dark chip (or the reverse) is unreadable, so the luminance of the chosen
// colour decides whether the label goes black or white.
const readableTextColour = (hex) => {
  const value = String(hex || '').replace('#', '');
  if (value.length !== 6) return '#ffffff';
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  // Rec. 709 luma - green contributes most of what the eye reads as bright.
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) > 150 ? '#1c2733' : '#ffffff';
};

export default function TagChip({ tag, onRemove }) {
  if (!tag) return null;

  return (
    <span
      className="tag-chip"
      style={{ backgroundColor: tag.colour, color: readableTextColour(tag.colour) }}
      title={tag.description || tag.name}
    >
      {tag.name}
      {onRemove && (
        <button
          type="button"
          className="tag-chip-remove"
          style={{ color: readableTextColour(tag.colour) }}
          onClick={(e) => { e.stopPropagation(); onRemove(tag); }}
          aria-label={`Remove ${tag.name}`}
        >
          &times;
        </button>
      )}
    </span>
  );
}
